import createDocumentSlice from "./createDocumentSlice";
import { config } from "../../utils/apiUrl";

/*
|--------------------------------------------------------------------------
| PROFORMA INVOICE MODULE
|--------------------------------------------------------------------------
*/

const proformaInvoiceModule =
  createDocumentSlice({
    sliceName:
      "proformaInvoice",

    stateKey:
      "proformaInvoice",

    documentName:
      "Proforma Invoice",

    documentType:
      "PROFORMA_INVOICE",

    documentKey:
      "proformaInvoice",

    documentKeys: [
      "sourceProformaInvoice",
    ],

    listKey:
      "proformaInvoices",

    urls: {
      list:
        config.getProformaInvoices,

      summary:
        config.getProformaInvoiceSummary,

      createData:
        config.getProformaInvoiceCreateData,

      dropdowns:
        config.getProformaInvoiceDropdowns,

      getById:
        config.getProformaInvoiceById,

      create:
        config.createProformaInvoice,

      update:
        config.updateProformaInvoice,

      confirm:
        config.confirmProformaInvoice,

      cancel:
        config.cancelProformaInvoice,

      duplicate:
        config.duplicateProformaInvoice,

      convert:
        config.convertProformaInvoice,

      delete:
        config.deleteProformaInvoice,

      history:
        config.getProformaInvoiceHistory,
    },

    initialFilters: {
      paymentStatus:
        "",

      fulfillmentStatus:
        "",
    },

    initialSummary: {
      unpaidCount:
        0,

      partiallyPaidCount:
        0,

      paidCount:
        0,
    },

    initialDropdowns: {
      documentStatuses:
        [],

      paymentStatuses:
        [],

      conversionStatuses:
        [],

      conversionTargets:
        [],

      salesChannels:
        [],

      priceModes:
        [],

      discountTypes:
        [],
    },

    supportsConfirm:
      true,

    supportsCancel:
      true,

    supportsDuplicate:
      true,

    supportsConvert:
      true,

    supportsDelete:
      true,

    supportsHistory:
      true,
  });

/*
|--------------------------------------------------------------------------
| REDUCER
|--------------------------------------------------------------------------
*/

export default
  proformaInvoiceModule.reducer;

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

export const {
  setFilters:
    setProformaInvoiceFilters,

  setFilter:
    setProformaInvoiceFilter,

  setPage:
    setProformaInvoicePage,

  setLimit:
    setProformaInvoiceLimit,

  resetFilters:
    resetProformaInvoiceFilters,

  setSelectedDocument:
    setSelectedProformaInvoice,

  clearSelectedDocument:
    clearSelectedProformaInvoice,

  clearHistory:
    clearProformaInvoiceHistory,

  clearErrors:
    clearProformaInvoiceErrors,

  clearOperation:
    clearProformaInvoiceOperation,

  clearLastCreatedDocument:
    clearLastCreatedProformaInvoice,

  clearLastDuplicatedDocument:
    clearLastDuplicatedProformaInvoice,

  clearLastConvertedDocument:
    clearLastConvertedProformaDocument,

  resetState:
    resetProformaInvoiceState,
} =
  proformaInvoiceModule.actions;

/*
|--------------------------------------------------------------------------
| THUNKS
|--------------------------------------------------------------------------
*/

export const {
  fetchDocuments:
    fetchProformaInvoices,

  fetchSummary:
    fetchProformaInvoiceSummary,

  fetchCreateData:
    fetchProformaInvoiceCreateData,

  fetchDropdowns:
    fetchProformaInvoiceDropdowns,

  fetchDocumentById:
    fetchProformaInvoiceById,

  createDocument:
    createProformaInvoice,

  updateDocument:
    updateProformaInvoice,

  confirmDocument:
    confirmProformaInvoice,

  cancelDocument:
    cancelProformaInvoice,

  duplicateDocument:
    duplicateProformaInvoice,

  convertDocument:
    convertProformaInvoice,

  deleteDocument:
    deleteProformaInvoice,

  fetchDocumentHistory:
    fetchProformaInvoiceHistory,
} =
  proformaInvoiceModule.thunks;

/*
|--------------------------------------------------------------------------
| SELECTORS
|--------------------------------------------------------------------------
*/

export const {
  selectModule:
    proformaInvoiceSelector,

  selectDocuments:
    proformaInvoiceListSelector,

  selectSelectedDocument:
    selectedProformaInvoiceSelector,

  selectSummary:
    proformaInvoiceSummarySelector,

  selectFilters:
    proformaInvoiceFiltersSelector,

  selectPagination:
    proformaInvoicePaginationSelector,

  selectCreateData:
    proformaInvoiceCreateDataSelector,

  selectDropdowns:
    proformaInvoiceDropdownsSelector,

  selectHistory:
    proformaInvoiceHistorySelector,

  selectLoading:
    proformaInvoiceLoadingSelector,

  selectOperation:
    proformaInvoiceOperationSelector,
} =
  proformaInvoiceModule.selectors;